import React, { type ReactNode } from 'react';
import { ActionIcon, Group, Stack, Text, Title } from '@mantine/core';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** Buttons shown on the right. */
  actions?: ReactNode;
  /** Show a back arrow that goes to this address. */
  back?: string;
}

const PageHeader = ({ title, description, actions, back }: PageHeaderProps) => {
  const navigate = useNavigate();

  return (
    <Group justify="space-between" align="center" wrap="wrap" gap="md" mb="lg">
      <Group gap="sm" wrap="nowrap">
        {back && (
          <ActionIcon
            variant="default"
            size="lg"
            aria-label="Go back"
            onClick={() => navigate(back)}
          >
            <ArrowLeft size={18} />
          </ActionIcon>
        )}
        <Stack gap={2}>
          <Title order={2} fz={{ base: 'h3', sm: 'h2' }}>
            {title}
          </Title>
          {description && (
            <Text c="dimmed" size="sm">
              {description}
            </Text>
          )}
        </Stack>
      </Group>
      {actions && <Group gap="sm">{actions}</Group>}
    </Group>
  );
};

export default PageHeader;
